export default {
  created: {
    title: 'создан',
    value: 'created',
  },
  accepted: {
    title: 'принят',
    value: 'accepted',
  },
  awaitingInStorage: {
    title: 'на складе',
    value: 'awaiting_in_storage',
  },
  readyToGiveaway: {
    title: 'готов к выдаче',
    value: 'ready_to_giveaway',
  },
  inDelivery: {
    title: 'доставляется',
    value: 'in_delivery'
  },
  completed: {
    title: 'завершен',
    value: 'completed'
  },
  canceled: {
    title: 'отменен',
    value: 'canceled'
  },
}
